import styled from "styled-components"

export const CountdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    align-items: center;
`

export const CountdownHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
    color: var(--plum-black);
    text-align: center;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 16px;
        gap: 4px;
    }
`

export const CountdownNumbersWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 0.276rem 1fr 0.276rem 1fr 0.276rem 1fr;

    align-items: center;
    justify-content: center;
    grid-gap: 8px;
`

export const CountdownNumber = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background-color: var(--organization-primary-color-1);
    border-radius: 8px;
    padding: 12px 8px;
    min-width: 48px;
    text-align: center;
    color: var(--contrasted-organization-primary-color-1);

    .number {
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
        color: var(--contrasted-organization-primary-color-1);
    }

    .label {
        font-size: 12px;
        font-weight: 500;
        text-transform: uppercase;
        line-height: normal;
        color: var(--contrasted-organization-primary-color-1);
        letter-spacing: 0.5px;
        padding: 0;
    }

    @media (max-width: 768px) {
        .number {
            font-size: 18px;
        }

        .label {
            font-size: 10px;
        }
    }

    @media (max-width: 480px) {
        min-width: 40px;

        .label {
            font-size: 8px;
        }
    }
`

export const Separator = styled.div`
    height: 1.09rem;
    width: 0.276rem;
    flex-shrink: 0;
    color: #ced4da;

    svg {
        display: block;
        width: 100%;
        height: 100%;
        max-width: none;
    }
`
